import React, { useEffect, useState } from 'react';
import { projectMilestoneServices } from '../../../APIServices/projectMilestoneServices';
import { useToast } from '../../../hooks/useToast';

function UpdateProjectMilestone({
  projectMilestoneData,
  setConfirm,
  confirm,
  setModalOpen,
  getProjectMilestoneData,
}) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [projectMilestone, setProjectMilestone] = useState('');
  const [defaultTimelineStatus, setDefaultTimelineStatus] = useState('planned');

  const updateProjectMilestoneData = async () => {
    setButtonLoader(true);
    try {
      const data = await projectMilestoneServices.updateProjectMilestoneData({
        projectMilestoneId: projectMilestoneData?.projectMilestoneId,
        projectMilestone,
        defaultTimelineStatus,
      });
      if (data?.statusCode === 200) {
        toast(data?.customMessage || 'Project milestone updated successfully.', 'ok');
        getProjectMilestoneData();
        setConfirm(false);
        setModalOpen('');
        setProjectMilestone('');
      } else {
        toast(data?.customMessage || 'Unable to update project milestone.', 'warn');
      }
    } catch (error) {
      toast('Unable to update project milestone. Please try again.', 'warn');
    } finally {
      setButtonLoader(false);
    }
  };

  useEffect(() => {
    setProjectMilestone(projectMilestoneData?.projectMilestone || '');
    setDefaultTimelineStatus(projectMilestoneData?.defaultTimelineStatus || 'planned');
  }, [projectMilestoneData]);

  return (
    <div className="modal-backdrop" onClick={() => setModalOpen('')}>
      <div className="modal" style={{ maxWidth: 480 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <div className="modal-title">Edit Project Milestone</div>
            <div className="xs muted">Update the milestone details</div>
          </div>
          <button className="icon-btn" onClick={() => setModalOpen('')}>
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <div className="field">
            <label className="field-label">
              Project Milestone Name
              <span className="req">*</span>
            </label>
            <input
              className="inp"
              autoFocus
              disabled={buttonLoader || confirm}
              placeholder="e.g., Site activation"
              value={projectMilestone}
              onChange={(e) => setProjectMilestone(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="field-label">Default Timeline Status</label>
            <select
              className="inp"
              disabled={buttonLoader || confirm}
              value={defaultTimelineStatus}
              onChange={(e) => setDefaultTimelineStatus(e.target.value)}
            >
              <option value="planned">Planned</option>
              <option value="active">Active</option>
              <option value="at_risk">At risk</option>
              <option value="delayed">Delayed</option>
              <option value="done">Done</option>
            </select>
          </div>
        </div>

        <div className="modal-foot">
          {confirm ? (
            <>
              <button className="btn btn-ghost" onClick={() => setConfirm(false)}>Cancel</button>
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
                onClick={updateProjectMilestoneData}
                disabled={buttonLoader || !projectMilestone}
              >
                {buttonLoader ? (
                  <>
                    <div className="buttonLoader"></div>
                    <span>Updating...</span>
                  </>
                ) : (
                  <>
                    <i className="ti ti-check"></i>
                    <span>Yes, Update It!</span>
                  </>
                )}
              </button>
            </>
          ) : (
            <>
              <button className="btn btn-ghost" onClick={() => setModalOpen('')}>Cancel</button>
              <button className="btn btn-primary d-flex align-items-center justify-content-center gap-2" onClick={() => setConfirm(true)}>
                Update Project Milestone
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default UpdateProjectMilestone;
